import { AlertCircle, RefreshCw } from "lucide-react";

const ERROR_COPY = {
  session: {
    title: "Session Expired",
    message: "Your sign-in session expired or is invalid.",
    hint: "Retry may reload cached data, but signing in again is usually required.",
    showRetry: true,
  },
  network: {
    title: "Connection Problem",
    message: "Could not connect to the server. Check your network and that the backend is running.",
    hint: null,
    showRetry: true,
  },
  server: {
    title: "Could Not Load Progress",
    message: "Something went wrong while loading progress data.",
    hint: null,
    showRetry: true,
  },
};

export const ProgressErrorState = ({ errorType, onRetry }) => {
  const copy = ERROR_COPY[errorType] || ERROR_COPY.server;

  return (
    <div
      className="border border-[#FF3B30]/40 bg-[#FF3B30]/5 p-12 text-center"
      data-testid="progress-error-state"
      role="alert"
    >
      <AlertCircle className="w-8 h-8 text-analytics-red mx-auto mb-4" strokeWidth={1.5} aria-hidden="true" />
      <h3 className="font-heading text-2xl tracking-wider uppercase">{copy.title}</h3>
      <p className="text-sm text-dark-text-secondary mt-3">{copy.message}</p>
      {copy.hint ? <p className="text-xs text-dark-text-muted mt-2">{copy.hint}</p> : null}
      {copy.showRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-6 inline-flex items-center gap-2 border border-dark-border hover:border-brand-primary px-6 py-3 text-xs tracking-[0.25em] uppercase font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-dark-surface-1"
          data-testid="progress-error-retry"
        >
          <RefreshCw className="w-4 h-4" strokeWidth={2} aria-hidden="true" />
          Try Again
        </button>
      ) : null}
    </div>
  );
};
